"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    shoppingCart: {
      actions: {
        addToCart: 'Add to Cart',
        buy: 'Buy',
        order: 'Order',
        remove: 'Remove'
      },
      cart: {
        total: {
          label: 'Total',
          helperText: '',
          helperTextPreview: ''
        },
        totalItems: {
          label: 'Total of Rows',
          helperText: '',
          helperTextPreview: ''
        },
        totalShipping: {
          label: 'Total Shipping',
          helperText: '',
          helperTextPreview: ''
        },
        totalPayment: {
          label: 'Total Payment',
          helperText: '',
          helperTextPreview: ''
        },
        totalTaxes: {
          label: 'Total Taxes',
          helperText: '',
          helperTextPreview: ''
        },
        resetCart: 'Reset Cart'
      },
      messages: {
        confirmResetCart: 'Are you sure you want to reset the Cart content?',
        giftClaim: 'You can get {quantity} of {productName} as a gift.',
        cartManipulations: {
          allRemoved: 'All items were removed from the Cart.',
          itemAdded: '{number, plural, one {An item} other {Items}} added to the Cart.',
          itemRemoved: '{number, plural, one {An item} other {Items}} removed from the Cart.',
          quantityChaged: 'The quantity purchased has changed.'
        }
      },
      components: {
        appBartActionCart: 'Cart',
        quantityField: {
          states: {
            quantityRounded: 'Quantity was rounded to nearest package size.'
          }
        },
        cartAsidePreview: {
          cartEmpty: 'Your shopping cart is empty'
        },
        cartAfterAddModal: {
          continueShopping: 'Continue shopping',
          goToCart: 'Go to cart',
          title: 'Item was added to cart',
          pcs: 'pcs.'
        }
      }
    }
  }
};
var _default = messages;
exports.default = _default;